import UnidadeTable from '../components/unidadeTable/UnidadeTable.vue'

export default {
  components: {
    UnidadeTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
